// Components
import { Skeleton } from '@/common-utils/components/ui/skeleton';
import { Card, CardContent } from '@/common-utils/components/ui/card';

/**
 * @returns {JSX} BarChartSkeleton
*/
function BarChartSkeleton() {
    // Constants
    const BAR_WIDTH_VALUES = [58, 92, 41];

    return (
        <Card className='border border-gray-300 rounded-md min-h-[280px]'>
            <CardContent>
                <div className='flex flex-col items-start gap-2 py-2 px-2'>
                    <Skeleton className='h-6 w-24 max-w-[20%] shrink-0 rounded-md sm:max-w-[240px]' />
                    <Skeleton className='h-4 w-16 max-w-[25%] shrink-0 rounded-md sm:max-w-[240px]' />
                </div>
                <div className='flex w-full justify-center text-xs outline-none py-4 px-2' >
                    <div className='flex w-full max-w-full flex-col justify-center gap-6 pl-1 pr-12' >
                        {BAR_WIDTH_VALUES.map((widthValue, index) => (
                            <div
                                key={index}
                                className='flex h-10 w-full shrink-0 items-center gap-2'
                            >
                                <div className='flex h-10 min-h-10 min-w-0 flex-1 items-center'>
                                    <Skeleton
                                        className='h-10 w-52 max-w-[45% rounded-[5px]'
                                        style={{ width: `${widthValue}%` }}
                                    />
                                </div>
                                <Skeleton className='h-3.5 w-14 shrink-0 rounded-md' />
                            </div>
                        ))}
                    </div>
                </div>
            </CardContent>
        </Card >
    );
}

export default BarChartSkeleton;
